import type { ReactNode } from 'react';
import classnames from 'classnames';
import { Row } from 'react-bootstrap';
import { ChapterTitle } from '../../atoms/chapterTitle/ChapterTitle';
import { Content } from '../content/Content';

interface IPageSectionProps {
    align?: 'center';
    bgColor?: 'white';
    children: ReactNode;
}

export function PageSection(props: Readonly<IPageSectionProps>) {
    return (
        <section
            className={classnames(
                'page-section',
                { 'has-background-white': props.bgColor === 'white' },
                { 'is-centered': props.align === 'center' }
            )}
        >
            {props.children}
        </section>
    );
}

interface IPageSectionForCardsProps extends IPageSectionProps {
    chapterTitle: string;
    md?: number;
}

export function PageSectionForCards(props: Readonly<IPageSectionForCardsProps>) {
    return (
        <PageSection {...props}>
            <Content>
                <ChapterTitle>{props.chapterTitle}</ChapterTitle>
                <Row>{props.children}</Row>
            </Content>
        </PageSection>
    );
}
